import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Card, Button, PageHeader } from 'antd'
import Filters, { FilterItem, Types } from '../../components/Filters'
import { QuestionTemplateForm } from '../../components/Forms'
import QuestionTemplateList from '../../components/QuestionTemplateList'
import { QuestionProvider, QuestionConsumer } from '../../context/QuestionContext'
import { QuestionTemplateProvider, QuestionTemplateConsumer } from '../../context/QuestionTemplateContext'

export default class QuestionTemplate extends Component {

  private questionTemplateDispatchOptions = {
    search: {
      questions: {
        with: {
          _count: true
        }
      }
    },
    options: {
      sort: ['name'],
      limit: 9999
    }
  } as const

  renderAdd = () => {
    const { permissions }: any = this.props
    if (!permissions.create) return null

    return (
      <Link to="question-template/add">
        <Button type="primary" shape="round">
          Add question template
        </Button>
      </Link>
    )
  }

  render() {
    const { permissions, history, match: { params: { templateUuid } } }: any = this.props

    return (
      <QuestionTemplateProvider>
        <QuestionProvider>
          <QuestionConsumer>
            {({ fetching: fetchingQuestions, questions, requestQuestionList }) => (
              <QuestionTemplateConsumer>
                {({ fetching, questionTemplate, questionTemplates, pagination, requestQuestionTemplateList, requestQuestionTemplateFind, requestQuestionTemplateSave }) => {

                  // Create or edit an entity
                  if (templateUuid) {
                    // We are editing, so we need to find the entity to edit
                    let addon: any = {
                      permissions: permissions,
                      history: history
                    }
                    if (templateUuid !== 'add') {
                      addon = {
                        ...addon,
                        uuid: templateUuid,
                        data: questionTemplate,
                        loadQuestionTemplate: requestQuestionTemplateFind
                      }
                    }

                    return (
                      <Card>
                        <PageHeader title={templateUuid === 'add' ? 'New Question Template' : 'Question Template'} onBack={() => history.goBack()}>
                          <QuestionTemplateForm
                            {...addon}

                            history={history}

                            loading={fetching}
                            contentLoading={fetchingQuestions}

                            questions={questions}
                            loadQuestions={requestQuestionList}

                            dispatchSave={requestQuestionTemplateSave}
                          />
                        </PageHeader>
                      </Card>
                    )
                  }

                  return (
                    <>
                      <Card title="Filters" style={{marginBottom: 25}} extra={this.renderAdd()}>
                        <Filters loading={fetching} history={history} defaultSubmitOptions={this.questionTemplateDispatchOptions} submitDispatch={requestQuestionTemplateList}>
                          {({ values, handleFilterChange }: any) => (
                            <FilterItem
                              name="name.ilike"
                              type={Types.INPUT}
                              placeholder="Filter by template Name"
                              value={values['name.ilike']}
                              options={{
                                input: {
                                  allowClear: true
                                }
                              }}
                              onChange={handleFilterChange}
                            />
                          )}
                        </Filters>
                      </Card>

                      <Card title="List of Question Templates">
                        <QuestionTemplateList loading={fetching} permissions={permissions} history={history} questionTemplates={questionTemplates} pagination={pagination} loadQuestionTemplates={requestQuestionTemplateList} />
                      </Card>
                    </>
                  )
                }}
              </QuestionTemplateConsumer>
            )}
          </QuestionConsumer>
        </QuestionProvider>
      </QuestionTemplateProvider>
    )
  }
}
